export { default } from '@mui/base/FocusTrap';